//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OPZDialog from '@/components/OPZDialog';
import OPZTable from '@/components/OPZTable';
import api from '@/api/WMS/return/returnAPI';
export default {
  components: {
    OPZDialog: OPZDialog,
    OPZTable: OPZTable
  },
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      dialog: {
        title: '退货单明细',
        width: 1000,
        visible: false,
        columns: [{
          prop: 'returnNo',
          label: '退件单号'
        }, {
          prop: 'sku',
          label: 'SKU'
        }, {
          prop: 'pictureUrl',
          label: '图片',
          type: 'image'
        }, {
          prop: 'batchNo',
          label: '批次'
        }, {
          prop: 'deliverQuantitys',
          label: '应退回数量'
        }, {
          prop: 'returnQuantitys',
          label: '退回数量'
        }, {
          prop: 'returnGoodQuantity',
          label: '退回良品数'
        }, {
          prop: 'returnBadQuantity',
          label: '退回次品数'
        }, {
          prop: 'spu',
          label: 'spu'
        }, {
          prop: 'color',
          label: '颜色/尺码',
          type: 'html',
          htmlFormatter: function htmlFormatter(val, _ref) {
            var size = _ref.size;
            return "".concat(val || '--', "/").concat(size || '--');
          }
        }, {
          prop: 'specifications',
          label: '规格'
        }],
        params: {
          returnNo: this.rowData.returnNo
        }
      }
    };
  },
  methods: {
    getGetReturnDetailOrPackDetail: api.getReturnDetailOrPackDetail
  }
};